import SuccessRegister from "./SuccessRegister";

export default SuccessRegister;
